module.exports = __webpack_public_path__ + "static/media/ice.4b19dc20.png";